import { gql } from '@apollo/client'
import VendNumber from 'vend-number'

type RefundEcwidSaleRequest = {
  /**
   * The id of the original sale that has been synced to X-series from an ecom sale
   */
  originalSaleID: string
  amount: VendNumber
  registerID: string
  registerSalePaymentID: string
}

export type RefundEcwidSaleVariables = {
  input: RefundEcwidSaleRequest
}
export type RefundEcwidSaleResponse = {
  refundEcwidSale: {
    success: boolean
  }
}

export const REFUND_ECOM_MUTATION = gql`
  mutation RefundEcwidSale($input: RefundEcwidSaleRequest!) {
    refundEcwidSale(input: $input) {
      success
    }
  }
`
